<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" :md="colsFilaPrincipal">
        <v-text-field
          v-model="solicitudPuestoForm.tituloOferta"
          class="rounded-lg"
          label="Título de la oferta*"
          placeholder="Escribir"
          outlined
          @input="
            (val) =>
              (solicitudPuestoForm.tituloOferta = (val || '').replace(
                /[^\p{L}\p{N}\s.:,¡!¿?\-()]/gu,
                ''
              ))
          "
          @keypress="
            $event.key.length === 1 &&
              !/^[\p{L}\p{N}\s.:,¡!¿?\-()]+$/u.test($event.key) &&
              $event.preventDefault()
          "
          @blur="$v.solicitudPuestoForm.tituloOferta.$touch()"
          :error-messages="tituloOfertaErrors"
          :readonly="isReadOnly"
          dense
          maxlength="80"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" :md="colsFilaPrincipal" v-if="tipoSolicitud === 2">
        <v-autocomplete
          v-model="solicitudPuestoForm.idSistemaPago"
          class="rounded-lg"
          :items="sistemaPago"
          placeholder="Seleccionar"
          :label="labelInputs.sistemaPago.label"
          outlined
          item-text="nombre"
          item-value="id"
          @blur="$v.solicitudPuestoForm.idSistemaPago.$touch()"
          :error-messages="sistemaPagoErrors"
          :readonly="isReadOnly"
          dense
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" :md="colsFilaPrincipal">
        <!-- Mostrar v-text-field en modo solo lectura -->
        <v-text-field
          v-if="isReadOnly"
          v-model="plazaTextoView"
          class="rounded-lg"
          :label="labelPlazaSolicitar"
          outlined
          readonly
          dense
        ></v-text-field>

        <!-- Mostrar v-autocomplete en modo edición -->
        <v-autocomplete
          v-else
          v-model="solicitudPuestoForm.plazaSolicitar"
          class="rounded-lg"
          :items="plaza"
          placeholder="Seleccionar"
          :label="labelPlazaSolicitar"
          @keyup="searchPlaza(true)"
          no-filter
          :search-input.sync="search_plaza"
          :no-data-text="'No existe la plaza deseada'"
          outlined
          item-text="nombre"
          item-value="id"
          return-object
          @change="changePlaza"
          @blur="$v.solicitudPuestoForm.plazaSolicitar.$touch()"
          :error-messages="plazaSolicitarErrors"
          dense
          ref="refPlaza"
          :disabled="tipoSolicitud === 2 && !solicitudPuestoForm.idSistemaPago"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" :md="colsFilaPrincipal">
        <v-text-field
          v-model.number="solicitudPuestoForm.vacantesSolicitar"
          class="rounded-lg"
          label="Cantidad a solicitar*"
          outlined
          @keypress="restrictInteger"
          @blur="$v.solicitudPuestoForm.vacantesSolicitar.$touch()"
          :error-messages="vacantesSolicitarErrors"
          placeholder="Número de vacantes a solicitar"
          :readonly="isReadOnly"
          dense
          :disabled="!solicitudPuestoForm.plazaSolicitar"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-row>
              <v-col cols="12" sm="6">
                <div
                  style="font-weight: 400 !important"
                  class="text-start text-subtitle-2"
                >
                  ¿Aplica para personas con discapacidad?
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <v-radio-group
                  v-model="solicitudPuestoForm.discapacidad"
                  row
                  :readonly="isReadOnly"
                  class="mt-0"
                >
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="solicitudPuestoForm.sexo"
              class="rounded-lg"
              :items="sexo"
              label="Sexo*"
              outlined
              placeholder="Sexo"
              item-text="nombre"
              item-value="id"
              no-data-text="No existe el sexo deseado"
              @blur="$v.solicitudPuestoForm.sexo.$touch()"
              :error-messages="sexoErrors"
              :readonly="isReadOnly"
              dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="solicitudPuestoForm.motivo"
              outlined
              label="Motivo*"
              class="rounded-lg"
              placeholder="Motivo"
              @blur="$v.solicitudPuestoForm.motivo.$touch()"
              :error-messages="motivoErrors"
              :readonly="isReadOnly"
              dense
            ></v-textarea>
          </v-col>
        </v-row>

        <!-- CUADRO DE APORTACIONES -->
        <v-row v-if="mostrarCuadroAportaciones">
          <v-col cols="12">
            <span class="font-weight-black primary--text">Cuadro de aportaciones</span>
            <CuadroAportaciones
              class="mt-2"
              :nombrePlaza="nombrePlazaSolicitar"
              :isView="false"
              :aportaciones="cuadroAportaciones"
              :faseActivaUsuario="cuadroFaseActivaUsuario"
              @calcularAportaciones="calcularAportaciones"
              @actualizarRangoSalarial="actualizarRangoSalarial"
              @verCuadroAportaciones="verCuadroAportaciones"
              :fase="faseActual"
              :salarioMinimo="salarioMinimo"
              :salarioMaximo="salarioMaximo"
              :rangoSalarialEditable="rangoSalarialEditableP14F2"
              :calcularAguinaldo="mostrarCheckboxAguinaldo"
              :calculadoAguinaldoSalario="calculadoAguinaldoSalario"
            ></CuadroAportaciones>
          </v-col>
        </v-row>

        <!-- CUADRO DE APORTACIONES SERVICIOS PROFESIONALES -->
        <v-row v-if="mostrarCuadroAportacionesServiciosProfesionales">
          <v-col cols="12">
            <span class="font-weight-black primary--text">Cuadro de aportaciones</span>
            <CuadroAportacionesServiciosProfesionales
              class="mt-2"
              :nombrePlaza="nombrePlazaSolicitar"
              :isView="isViewCuadroAportacionesServiciosProfesionales"
              :aportaciones="cuadroAportaciones"
              @calcularAportaciones="calcularAportaciones"
              @actualizarRangoSalarial="actualizarRangoSalarial"
              @verCuadroAportaciones="verCuadroAportaciones"
              :fase="faseActual"
              :salarioMinimo="salarioMinimo"
              :salarioMaximo="salarioMaximo"
              :rangoSalarialEditable="rangoSalarialEditableServiciosProfesionales"
            ></CuadroAportacionesServiciosProfesionales>
          </v-col>
        </v-row>

        <!-- SALARIO ASIGNADO -->
        <v-row dense v-if="mostrarSalarioAsignado">
          <v-col cols="12">
            <span>Salario asignado</span>
          </v-col>
          <v-col cols="12"> ${{ Number(salarioAsignado).toFixed(2) }} </v-col>
        </v-row>

        <!-- ASIGNACIÓN DE SALARIO -->
        <v-row class="d-flex justify-start" v-if="mostrarAsignacionSalario">
          <v-col class="d-flex justify-start" cols="4">
            <v-checkbox
              class="pr-5"
              dense
              label="Definir salario"
              v-model="definirSalario"
              :disabled="!esFaseActivaUsuario"
            />
            <v-currency-field
              v-if="definirSalario"
              v-model="solicitudPuestoForm.salarioPropuesto"
              class="rounded-lg"
              label="Salario"
              placeholder="Escriba"
              outlined
              prefix="$"
              maxlength="20"
              dense
              @input="validarRangoSalario"
              @blur="$v.solicitudPuestoForm.salarioPropuesto.$touch()"
              :error-messages="salarioPropuestoErrors"
            />
          </v-col>
          <v-col cols="2" class="d-flex align-start" v-if="definirSalario">
            <div>
              <div class="text-caption grey--text text--darken-1">
                Salario mínimo
              </div>
              <div class="text-body-2 font-weight-medium">
                {{
                  salarioMinimo ? $currency.format(salarioMinimo) : "Indefinido"
                }}
              </div>
            </div>
          </v-col>
          <v-col cols="2" class="d-flex align-start" v-if="definirSalario">
            <div>
              <div class="text-caption grey--text text--darken-1">
                Salario máximo
              </div>
              <div class="text-body-2 font-weight-medium">
                {{
                  salarioMaximo ? $currency.format(salarioMaximo) : "Indefinido"
                }}
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- CIFRADO ASIGNADO -->
        <v-row dense v-if="mostrarCifradoAsignado">
          <v-col cols="12" class="mt-4">
            <span class="font-weight-black primary--text">Asignación de cifrado presupuestario</span>
            <MostrarCifradoPresupuestario
              :dataCifrado="{
                cifrado: solicitud.cifrado_presupuestario_asignado?.codigo_cifrado
                  || solicitud.cifradoDefinicion?.cifrado?.codigo
                  || solicitud.codigo_cifrado,
                cuenta: solicitud.cifradoDefinicion?.cuenta?.nombre,
                especifico: solicitud.cifradoDefinicion?.especifico?.nombre,
                rubro: solicitud.cifradoDefinicion?.rubro?.nombre,
                monto: solicitud.cifrado_presupuestario_asignado?.monto,
                partida: solicitud.cifrado_presupuestario_asignado?.partida
              }"
              :readonly="true"
            />
          </v-col>
          <v-col cols="12"> </v-col>
        </v-row>
      </v-col>

      <!-- DOCUMENTOS -->
      <v-col cols="12">
        <DocumentosSolicitud
          :id-solicitud-contratacion="idSolicitudContratacion"
          :puede_agregar="!isView"
          :puede_modificar="!isView"
          :version="'solicitud'"
          ref="documentosSolicitud"
        ></DocumentosSolicitud>
      </v-col>

      <!-- GESTION CANDIDATOS BOLSON -->
      <v-col cols="12" v-if="mostrarCandidatosBolson">
        <GestionCandidatosBolson ref="gestionCandidatosBolson" />
      </v-col>

      <slot name="buttom" />
      <slot name="dialogs" />
    </v-row>

    <!-- Modal para ver el cuadro de aportaciones -->
    <AppDialog
      v-model="showCuadroDialog"
      max-width="800"
      title="Cuadro de aportaciones"
    >
      <template #body>
        <embed
          :src="cuadroDocumentToView"
          style="width: 100%; height: 600px"
          type="application/pdf"
        />
      </template>
      <template #actions>
        <v-row justify="center" class="mb-4">
          <v-btn
            color="primary"
            class="rounded-xl"
            style="text-transform: none"
            outlined
            @click="showCuadroDialog = false"
            >Cerrar</v-btn
          >
        </v-row>
      </template>
    </AppDialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import jwtDecode from "jwt-decode";
import {
  minValue,
  maxValue,
  requiredIf,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
import { withParams } from "vuelidate/lib/validators/common";
import { mapMutations } from "vuex/dist/vuex.common.js";
import DocumentosSolicitud from "../../../../../components/DocumentosSolicitud.vue";
import CuadroAportaciones from "./CuadroAportaciones.vue";
import CuadroAportacionesServiciosProfesionales from "./CuadroAportacionesServiciosProfesionales.vue";
import CifradoPresupuestarioComponent from "../aprobacion/component/CifradoPresupuestarioComponent.vue";
import MostrarCifradoPresupuestario from "./MostrarCifradoPresupuestario.vue";
import GestionCandidatosBolson from "./GestionCandidatosBolson.vue";
import { decodeFase } from "@/utils/faseEncoding";
import solicitudServices from "@/services/solicitud.services.js";

export default {
  name: "Solicitud",
  components: {
    DocumentosSolicitud,
    CuadroAportaciones,
    CuadroAportacionesServiciosProfesionales,
    CifradoPresupuestarioComponent,
    MostrarCifradoPresupuestario,
    GestionCandidatosBolson
  },
  props: {
    rol: {
      type: String,
      required: true
    },
    idSoli: {
      type: Number,
      default: () => 7
    },
    sendSolicitud: { type: Function },
    dataSolicitud: { type: Object },
    isView: { type: Boolean },
    faseSolicitud: {
      type: Object,
      default: null
    },
    vieneDetalleGralSolicitudes: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    const notEmojis = (value) => {
      const x = value?.match(
        /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu
      );
      if (x != null) {
        return false;
      } else {
        return true;
      }
    };

    const maxVacantes = (max) =>
      withParams({ type: "maxVacantes", max: max }, (value) => {
        const valorIngresado = parseInt(value, 10);
        const limiteMaximo = parseInt(max, 10);
        return valorIngresado <= limiteMaximo;
      });
    return {
      solicitudPuestoForm: {
        tituloOferta: {
          required: requiredIf(function () {
            return !this.isReadOnly;
          }),
          notEmojis,
          maxLength: maxLength(80)
        },
        plazaSolicitar: {
          required: requiredIf(function () {
            return !this.isReadOnly;
          })
        },
        idSistemaPago: {
          required: requiredIf(function () {
            // Solo requerido para tipo de solicitud 2 y cuando no está en modo readonly
            return this.tipoSolicitud === 2 && !this.isReadOnly;
          })
        },
        partida: {
          required: requiredIf(function () {
            return ["ufi"].includes(this.$route.query.solicitud);
          })
        },
        cifrado: {
          required: requiredIf(function () {
            return ["ufi"].includes(this.$route.query.solicitud);
          })
        },
        vacantesSolicitar: {
          required: requiredIf(function () {
            return !this.isReadOnly;
          }),
          numeric,
          minValue: minValue(1),
          validMaxVacantes: function (value) {
            // Solo validar disponibilidad si el tipo de solicitud es 2
            const tipo =
              Number(this.tipoSolicitud) || Number(this.$route.query.tipo);
            if ([1, 3].includes(tipo)) {
              return true;
            }

            // Para tipo 2: validar que no exceda las vacantes disponibles
            const disponible =
              Number(this.solicitudPuestoForm.vacantesDisponible) || 0;
            const solicitado = Number(value) || 0;
            return solicitado <= disponible;
          }
        },
        motivo: {
          required: requiredIf(function () {
            return !this.isReadOnly;
          }),
          notEmojis,
          maxLength: maxLength(500)
        },
        sexo: {
          required: requiredIf(function () {
            return !this.isReadOnly;
          })
        },
        salarioPropuesto: {
          required: requiredIf(function () {
            return this.definirSalario && !this.isReadOnly;
          }),
          validNumeric: function (value) {
            if (!this.definirSalario) return true;
            if (!value && value !== 0) return false;
            const numericValue = Number(value);
            return !isNaN(numericValue) && numericValue > 0;
          },
          minValue: function (value) {
            if (!this.definirSalario) return true;
            const salario = Number(value) || 0;
            const minimo = Number(this.salarioMinimo) || 0;
            if (minimo === 0) return true;
            return salario >= minimo;
          },
          maxValue: function (value) {
            if (!this.definirSalario) return true;
            const salario = Number(value) || 0;
            const maximo = Number(this.salarioMaximo) || 0;
            if (maximo === 0) return true;
            return salario <= maximo;
          }
        }
      }
    };
  },
  data() {
    return {
      cuadroFaseActivaUsuario: false,
      sistemaPagoContrato: null,
      plazaVacante: 2,
      plazaGOES: 1,
      PlazaServiciosProfesionales: 3,
      listadoEmpleadoDelegar: [],
      codigoCifradoData: "",
      nombrePlazaSolicitar: "",
      definirSalario: false,
      solicitud_fase_solicitud: null,
      idSolicitudContratacion: null,
      tipoSolicitud: null,
      estado_solicitud_borrador: false,
      labelInputs: {
        plaza: {
          label: "Plaza a solicitar*"
        },
        sistemaPago: {
          label: "Sistema de pago*"
        }
      },
      id_unidad_solicitante: null,
      search_cargo: "",
      search_plaza: "",
      id_establecimiento: null,
      solicitudPuestoForm: {
        fechaSolicitud: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        unidad: null,
        tituloOferta: null,
        idSistemaPago: null,
        plazaSolicitar: null,
        partida: null,
        // tipoContratacion: null,
        cifrado: null,
        vacantesDisponible: 0,
        vacantesSolicitar: null,
        motivo: null,
        salarioPropuesto: null,
        tipoHorario: null,
        horario: null,
        discapacidad: null,
        sexo: null,
        cantdadDisponible: null
      },
      salarioMaximo: 0,
      salarioMinimo: 0,
      rangoSalarialEditableP14F2: false,
      rangoSalarialEditableServiciosProfesionales: false,
      cifrados: [],
      plaza: [],
      partidas: [],
      tipoContratacion: [],
      dirUniArea: [],
      tiposHorarios: [],
      horarios: [],
      sexo: [],
      isSearchingCargo: false,
      isSearchingPlaza: false,
      cargoSelected: null,
      changedCargo: false,
      isCreated: false,
      returnDate: false,
      cleanedOferta: {},
      itemsDocumentos: [],
      nombrePlaza: "",
      cuadroAportaciones: {
        honorario: 0,
        totalHonorariosMensual: 0,
        costoPlaza: 0,
        plazas: 0,
        costoTotalPlazas: 0,
        isss: 0,
        afp: 0,
        isr: 0,
        totalIsss: 0,
        totalAfp: 0,
        totalIsr: 0,
        aguinaldoIndividual: 0,
        aguinaldoTotal: 0,
        salarioMinimo: null,
        salarioMaximo: null
      },
      salarioAsignado: "$100",
      sistemaPago: [],
      showCuadroDialog: false,
      cuadroDocumentToView: null,
      advertenciaRangoSalario: "",
      calcularAguinaldo: false,
      calculadoAguinaldoSalario: null
    };
  },
  methods: {
    ...mapMutations("utils", ["setLoader"]),

    validarRangoSalario(value) {
      const salario = Number(value) || 0;
      const minimo = Number(this.salarioMinimo) || 0;
      const maximo = Number(this.salarioMaximo) || 0;

      if (salario > 0) {
        if (minimo > 0 && salario < minimo) {
          this.advertenciaRangoSalario = `El salario debe ser mayor o igual a ${this.$currency.format(minimo)}`;
        } else if (maximo > 0 && salario > maximo) {
          this.advertenciaRangoSalario = `El salario debe ser menor o igual a ${this.$currency.format(maximo)}`;
        } else {
          this.advertenciaRangoSalario = "";
        }
      } else {
        this.advertenciaRangoSalario = "";
      }

      this.$v.solicitudPuestoForm.salarioPropuesto.$touch();
    },

    actualizarRangoSalarial({ salarioMinimo, salarioMaximo }) {
      this.salarioMinimo = salarioMinimo;
      this.salarioMaximo = salarioMaximo;
      this.cuadroAportaciones = {
        ...this.cuadroAportaciones,
        salarioMinimo,
        salarioMaximo
      };
    },

    validarCuadroAportacionesCompleto() {
      const c = this.cuadroAportaciones;
      if (!c) return false;
      return Number(c.honorario) > 0 && Number(c.costoTotalPlazas) > 0;
    },

    validarRangoCuadroAportaciones() {
      const requiereValidacionP14F2 = this.faseActual === "P14-F2";
      const requiereValidacionServiciosProfesionales = Number(this.tipoSolicitud) === 3
        && this.faseActual === "P15-F3"
        && Number(this.idEstado) === 4;
      if (!requiereValidacionP14F2 && !requiereValidacionServiciosProfesionales) return true;

      const salarioMinimo = Number(this.salarioMinimo);
      const salarioMaximo = Number(this.salarioMaximo);
      const honorario = Number(this.cuadroAportaciones?.honorario);

      if (!(salarioMinimo > 0) || !(salarioMaximo > 0)) {
        this.temporalAlert({
          show: true,
          message: "Debe ingresar correctamente el salario mínimo y el salario máximo",
          type: "warning"
        });
        return false;
      }
      if (salarioMinimo > salarioMaximo) {
        this.temporalAlert({
          show: true,
          message: "El salario mínimo no puede ser mayor que el salario máximo",
          type: "warning"
        });
        return false;
      }
      if (!(honorario >= salarioMinimo && honorario <= salarioMaximo)) {
        this.temporalAlert({
          show: true,
          message: `El salario debe estar entre ${this.$currency.format(salarioMinimo)} y ${this.$currency.format(salarioMaximo)}`,
          type: "warning"
        });
        return false;
      }

      return true;
    },

    // Envía la solicitud
    async emitirData() {
      this.$v.solicitudPuestoForm.$touch();

      if (this.$v.solicitudPuestoForm.$invalid) {
        this.temporalAlert({
          show: true,
          message: "Faltan campos por completar en la solicitud",
          type: "warning"
        });
        return;
      }

      // Validar cuadro de aportaciones antes de enviar
      const mostrarCuadro = this.mostrarCuadroAportaciones || this.mostrarCuadroAportacionesServiciosProfesionales;
      if (mostrarCuadro && !this.validarCuadroAportacionesCompleto()) {
        this.temporalAlert({
          show: true,
          message: "Se deben completar todos los campos del apartado del cuadro de aportaciones",
          type: "warning"
        });
        return;
      }

      const removeObjectEmptyValues = (obj) => {
        // Obtenemos las llaves que tienen valores nulos o una cadena vacía
        const keysToRemove = Object.keys(obj).filter(
          (key) => obj[key] === null || obj[key] === ""
        );
        // Eliminamos las llaves del objeto
        keysToRemove.forEach((key) => {
          //* no se tiene que borrar si va null el id_categoria_plaza
          if (key !== "id_categoria_plaza") delete obj[key];
        });
        return obj;
      };
      let oferta = {
        titulo_oferta: this.solicitudPuestoForm.tituloOferta,
        idSistemaPago: this.solicitudPuestoForm.idSistemaPago,
        id_detalle_plaza:
          typeof this.solicitudPuestoForm.plazaSolicitar === "object"
            ? this.solicitudPuestoForm.plazaSolicitar.id
            : this.solicitudPuestoForm.plazaSolicitar,
        numero_vacantes: Number(this.solicitudPuestoForm.vacantesSolicitar),
        motivo_numero_vacante: this.solicitudPuestoForm.motivo,
        discapacidad: this.solicitudPuestoForm.discapacidad,
        id_sexo: this.solicitudPuestoForm.sexo,
        id_tipo_solicitud: this.tipoSolicitud,
        salario_propuesto: this.definirSalario
          ? Number(this.solicitudPuestoForm.salarioPropuesto)
          : null,
        salario: this.definirSalario
          ? Number(this.solicitudPuestoForm.salarioPropuesto)
          : null,
        cuadro_aportaciones: this.cuadroAportaciones
      };

      if (this.mostrarCandidatosBolson && this.$refs.gestionCandidatosBolson) {
        oferta.candidatos_bolson = this.$refs.gestionCandidatosBolson.listadoSeleccionados;
      }

      if (this.isCreated) oferta.id_solicitud = Number(this.$route.params.id);
      const cleanedOferta = removeObjectEmptyValues(oferta);
      return this.returnDate
        ? cleanedOferta
        : this.$props.sendSolicitud(cleanedOferta);
    },

    // Obtiene la solicitud
    async getSolicitud() {
      const id = this.$route.params.id ?? null;
      if (!id) return;
      const estadoQuery = Number(this.$route.query.estado);
      let usarBitacora = !isNaN(estadoQuery) && estadoQuery !== 4 && estadoQuery !== 1 && estadoQuery !== 10;
      //if exclusivo del visualizador Coordinador de servicios operacionales
      if(usarBitacora && this.faseQuery === "P19-F8" && estadoQuery === 19){
        usarBitacora = false;
      }
      let response;
      if (usarBitacora) {
        response = await solicitudServices.getBitacoraSolicitud(id, {
          codigo_visualizacion: decodeFase(this.$route.query.fase)
        });
        if (response.status === 404) {
          response = await this.services.catalogos.getSolicitud(id, {id_tabs: this.tabOrigen});
        }
      } else {
        response = await this.services.catalogos.getSolicitud(id, {id_tabs: this.tabOrigen});
      }

      if (response.status === 200) {
        this.$emit("input", response.data.solicitud);
        this.estado_solicitud_borrador = response.data?.solicitud
          ?.estado_fase_solicitud
          ? true
          : false;
        this.idSolicitudContratacion = response.data.solicitud.id;
        this.solicitud_fase_solicitud =
          response.data.solicitud.solicitud_fase_solicitud;
        this.solicitudPuestoForm.fechaSolicitud =
          response.data.solicitud.fecha_solicitud;
        this.solicitudPuestoForm.unidad = response.data.solicitud.unidad.nombre;
        this.id_unidad_solicitante = response.data.solicitud.unidad.id;
        this.solicitudPuestoForm.tituloOferta =
          response.data.solicitud.titulo_oferta;
        this.nombrePlaza = response.data.solicitud?.nombre_detalle_plaza;
        this.solicitudPuestoForm.plazaSolicitar =
          response.data.solicitud.id_detalle_plaza;
        this.solicitudPuestoForm.idSistemaPago =
          response.data.idSistemaPago?.[0] || response.data.solicitud?.sistema_pago?.id || null;
        if (this.sistemaPagoFijo) {
          this.sistemaPagoContrato = this.solicitudPuestoForm.idSistemaPago;
        }
        if (this.isView) {
          this.nombrePlazaSolicitar = `${response.data.solicitud?.nombre_plaza}`;
          this.solicitudPuestoForm.vacantesDisponible =
            response.data.solicitud.total_disponible_vacantes;
        }
        this.salarioAsignado = response.data.solicitud.salario;

        this.tipoSolicitud = response.data.solicitud.tipo_solicitud.id;

        await this.getPlaza();
        const plazaEncontrada = this.plaza.find(
          (plaza) => plaza.id === response.data.solicitud.id_detalle_plaza
        );
        plazaEncontrada &&
          (await this.changePlaza({
            id_plaza_establecimiento: plazaEncontrada.id_plaza_establecimiento
          }));

        this.solicitudPuestoForm.cargoSolicitar =
          response.data.solicitud.id_cargo_funcional;
        this.cargoSelected = response.data.solicitud.id_cargo_funcional;
        localStorage.setItem("id_cargo", this.cargoSelected);
        this.salarioMinimo = plazaEncontrada
          ? plazaEncontrada.salario_minimo
          : response.data.solicitud.salario_minimo;
        this.salarioMaximo = plazaEncontrada
          ? plazaEncontrada.salario_maximo
          : response.data.solicitud.salario_maximo;
        const rangoDetallePlazaConfigurado = Number(this.salarioMinimo) > 0
          && Number(this.salarioMaximo) > 0;
        const cuadroAportacionesPersistido = response.data.solicitud.cuadro_aportacion
          ?? response.data.solicitud.cuadro_aportaciones
          ?? null;
        const rangoCuadroAportacionesConfigurado =
          Number(
            cuadroAportacionesPersistido?.salarioMinimo
              ?? cuadroAportacionesPersistido?.salario_minimo
          ) > 0
          && Number(
            cuadroAportacionesPersistido?.salarioMaximo
              ?? cuadroAportacionesPersistido?.salario_maximo
          ) > 0;
        if (response.data.solicitud?.presupuesto_asignado) {
          this.solicitudPuestoForm.cifrado = response.data.solicitud.id_cifrado;
          this.solicitudPuestoForm.partida =
            response.data.solicitud.id_detalle_plaza;
        }
        this.solicitudPuestoForm.salarioPropuesto = response.data.solicitud
          .salario_propuesto
          ? response.data.solicitud.salario_propuesto
          : response.data?.solicitud?.salario;
        this.solicitudPuestoForm.vacantesSolicitar =
          response.data.solicitud.numero_vacantes;
        this.solicitudPuestoForm.motivo =
          response.data.solicitud.motivo_numero_vacante;
        // await this.getTipoHorario();
        this.solicitudPuestoForm.tipoHorario =
          response.data.solicitud.id_tipo_horario;
        // this.solicitudPuestoForm.horario = response.data.solicitud.id_jornada;
        this.solicitudPuestoForm.discapacidad =
          response.data.solicitud.discapacidad;
        this.solicitudPuestoForm.sexo = response.data.solicitud.id_sexo;
        this.fase_avanzar = response.data.solicitud.fase_avanzar;
        const idEstadoRespuesta = response.data.solicitud.id_estado_fase_solicitud
          ?? response.data.solicitud.id_estado_fase_activa_usuario
          ?? response.data.solicitud.solicitud_fase_solicitud?.id_estado_fase_solicitud;
        this.idEstado = Number.isFinite(estadoQuery) && estadoQuery > 0
          ? estadoQuery
          : Number(idEstadoRespuesta);
        this.IdSolicitud = this.$route.params.id;

        //CODIGO CIFRADO

        if (response.data?.solicitud?.codigo_cifrado) {
          this.codigoCifradoData =
            response.data.solicitud.cifrado_presupuestario_asignado;
        }
        // Cargar cuadro de aportaciones si existe (viene como cuadro_aportacion en singular del backend)
        this.cuadroFaseActivaUsuario =
          response.data.solicitud.fase_activa_usuario;
        if (cuadroAportacionesPersistido) {
          const cuadro = cuadroAportacionesPersistido;
          const usarRangoDetallePlaza = this.faseQuery === "P15-F2";
          const salarioMinimoPersistido = usarRangoDetallePlaza
            ? this.salarioMinimo
            : cuadro.salarioMinimo ?? this.salarioMinimo;
          const salarioMaximoPersistido = usarRangoDetallePlaza
            ? this.salarioMaximo
            : cuadro.salarioMaximo ?? this.salarioMaximo;
          this.salarioMinimo = Number(salarioMinimoPersistido) || 0;
          this.salarioMaximo = Number(salarioMaximoPersistido) || 0;
          this.cuadroAportaciones = {
            honorario: Number(cuadro.honorario) || 0,
            totalHonorariosMensual: Number(cuadro.totalHonorariosMensual) || 0,
            costoPlaza: Number(cuadro.costoPlaza) || 0,
            plazas: Number(cuadro.plazas) || 0,
            costoTotalPlazas: Number(cuadro.costoTotalPlazas) || 0,
            isss: Number(cuadro.isss) || 0,
            afp: Number(cuadro.afp) || 0,
            isr: Number(cuadro.isr) || 0,
            totalIsss: Number(cuadro.totalPlazaISSS) || 0,
            totalAfp: Number(cuadro.totalPlazaAFP) || 0,
            totalIsr: Number(cuadro.totalPlazaISR) || 0,
            aguinaldoIndividual: Number(cuadro.aguinaldoIndividual) || 0,
            aguinaldoTotal: Number(cuadro.aguinaldoTotal) || 0,
            salarioMinimo: this.salarioMinimo,
            salarioMaximo: this.salarioMaximo
          };
        }
        const esEstadoPendiente = Number(this.idEstado) === 4;
        this.rangoSalarialEditableP14F2 = this.faseQuery === "P14-F2"
          && esEstadoPendiente
          && !rangoDetallePlazaConfigurado
          && !rangoCuadroAportacionesConfigurado;
        this.rangoSalarialEditableServiciosProfesionales = this.faseQuery === "P15-F3"
          && esEstadoPendiente
          && !rangoDetallePlazaConfigurado
          && !rangoCuadroAportacionesConfigurado;
        if (this.faseQuery === "P15-F2" && !this.tieneRangoSalarialDefinido) {
          this.definirSalario = false;
        }

        // En P15-F3 (Servicios Profesionales) el cuadro debe reflejar el
        // salario asignado
        const salarioAsignado =
          response.data.solicitud.salario_propuesto ??
          response.data.solicitud.salario ??
          null;
        if (
          this.faseQuery === "P15-F3" &&
          Number(this.tipoSolicitud) === 3 &&
          salarioAsignado != null &&
          Number(this.cuadroAportaciones.honorario) !== Number(salarioAsignado)
        ) {
          await this.calcularAportaciones(String(salarioAsignado), false);
        }
        this.calcularAguinaldo = (response.data.solicitud.calcular_aguinaldo && response.data.solicitud.fase_activa_usuario);
        this.calculadoAguinaldoSalario = response.data.solicitud.calculado_aguinaldo_salario ?? null;

        this.syncSolicitudStore({
          solicitud: response.data.solicitud
        });
        if (this.faseQuery === "P15-F2") {
          this.$store.dispatch("solicitud/setSalarioPropuesto", null);
        }
      }
    },
    getListadoPersonasDelegar() {
      try {
        const response = this.services.catalogos.getListadoPersonasDelegar();
      } catch (error) {
        console.error(
          "Error al obtener el listado de personas para delegar:",
          error
        );
      }
    },
    // Actualiza el store
    syncSolicitudStore({ solicitud } = {}) {
      if (solicitud !== undefined) {
        this.$store.dispatch("solicitud/setSolicitud", solicitud);
      }

      const codigoFase = solicitud?.codigo_fase ?? null;
      const esFaseActiva = solicitud?.fase_activa_usuario ?? false;
      this.$store.dispatch("solicitud/setFaseActual", codigoFase);
      this.$store.dispatch("solicitud/setEsFaseActivaUsuario", esFaseActiva);
      this.$store.dispatch(
        "solicitud/setEstadoFaseActiva",
        solicitud?.id_estado_fase_activa_usuario
      );
    },

    timeout(ms = 1000) {
      if (this.searchTimeout) {
        clearInterval(this.searchTimeout);
      }
      return new Promise((resolve) => {
        this.searchTimeout = setTimeout(resolve, ms);
      });
    },

    async changePlaza(event) {
      const {
        data: { data }
      } = await this.services.catalogos.getCifrados(
        event.id_plaza_establecimiento
      );
      this.cifrados = data;
      let params = {
        id_plaza_establecimiento: event?.id_plaza_establecimiento,
        id_unidad_solicitante: this.id_unidad_solicitante
      };
      if (Number(this.tipoSolicitud) === 2) {
        params.id_detalle_plaza_env = event?.id;
      }
      const {
        data: { total_disponible }
      } = await this.services.catalogos.getVacantesSubpartida(params);
      this.solicitudPuestoForm.vacantesDisponible =
        Number(total_disponible) || 0;
    },

    async getSexo() {
      const response = await this.services.catalogos.getCatalogo("sexo");
      this.sexo = response.data;
    },
    async getTipoHorario() {
      const response = await this.services.catalogos.getCatalogo(
        "tipo_horario"
      );
      this.tiposHorarios = response.data;
    },

    async getPlaza() {
      let params = {
        pagination: false,
        per_page: 5,
        id_search: this.solicitudPuestoForm.plazaSolicitar,
        id_sistema_pago: this.sistemaPagoFijo
          ? this.sistemaPagoContrato
          : this.solicitudPuestoForm.idSistemaPago,
      };
      if (this.sistemaPagoFijo) {
        params.solo_plazas_disponibles = false;
      }

      if (this.id_establecimiento)
        params.id_establecimiento = this.id_establecimiento;

      params.solo_plazas_disponibles = true;

      if ([1, 3].includes(Number(this.tipoSolicitud))) {
        params.solo_plazas_disponibles = false;
      }

      const response = await this.services.catalogos.getCatalogo(
        "plaza",
        params
      );

      this.plaza = response.data?.data || response.data || [];
    },
    async getDirUniArea() {
      const { data } = await this.services.catalogos.getUnidad(
        this.$route.params.id
      );
      this.dirUniArea = data;
    },
    async searchPlaza(typing = false) {
      if (typing) {
        this.isSearchingPlaza = typing;
        await this.timeout();
      }

      const params = {
        busqueda: this.search_plaza,
        id_sistema_pago: this.sistemaPagoFijo
          ? this.sistemaPagoContrato
          : this.solicitudPuestoForm.idSistemaPago,
      };

      if (this.id_establecimiento) {
        params.id_establecimiento = this.id_establecimiento;
      }

      params.solo_plazas_disponibles = true;
      if (this.sistemaPagoFijo) {
        params.solo_plazas_disponibles = false;
      }
      if ([1, 3].includes(Number(this.tipoSolicitud))) {
        params.solo_plazas_disponibles = false;
      }

      const response = await this.services.catalogos.getCatalogo(
        "plaza",
        params
      );
      this.isSearchingPlaza = !typing;

      this.plaza = response.status == 200 ? response.data : [];
    },
    async updateSolicitud({ func, estado }) {
      try {
        this.returnDate = true;
        const mostrarCuadro = this.mostrarCuadroAportaciones || this.mostrarCuadroAportacionesServiciosProfesionales;
        if (mostrarCuadro && !this.validarCuadroAportacionesCompleto()) {
          this.temporalAlert({
            show: true,
            message: "Se deben completar todos los campos del apartado del cuadro de aportaciones",
            type: "warning"
          });
          func(false);
          this.returnDate = false;
          return;
        }

        if (!this.validarRangoCuadroAportaciones()) {
          func(false);
          this.returnDate = false;
          return;
        }
        this.$v.solicitudPuestoForm.$touch();
        if (this.$v.solicitudPuestoForm.$invalid) {
          this.temporalAlert({
            show: true,
            message: "Faltan campos por completar en la solicitud",
            type: "warning"
          });
          return;
        }
        if (!this.$v.solicitudPuestoForm.$invalid) {
          const data = await this.emitirData();
          data.presupuesto_asignado = true;

          // Agregar cuadro de aportaciones al data que se envía
          data.cuadro_aportaciones = this.cuadroAportaciones;

          this.setLoader(true);
          const response = await this.services.catalogos.updateSolicitud(data);
          if (response.status === 200 || response.status === 201) {
            this.temporalAlert({
              show: true,
              message: "Actualizado exitosamente",
              type: "success"
            });
            this.setLoader(false);
            func(true);
            // Emitir evento con cuadro de aportaciones
            this.eventBus.$emit(
              "UpdateEstadoFase",
              estado,
              this.cuadroAportaciones
            );
            this.returnDate = false;
          }
        } else {
          func(false);
          this.returnDate = false;
        }
      } catch (error) {
        func(false);
        this.returnDate = false;
      }
    },

    async getSistemasPago() {
      const response = await this.services.catalogos.getSistemaPago();
      if (response.status === 200 || response.status === 201) {
        this.sistemaPago = response.data;
      } else {
        this.sistemaPago = [];
      }
    },

    async calcularAportaciones(aportaciones, calcularConSalarioMin = false) {
      if (!aportaciones) {
        this.temporalAlert({
          show: true,
          message: "Debe definir un salario para calcular las aportaciones",
          type: "warning"
        });
        return;
      }
      try {
        this.setLoader(true);
        const uri = `${process.env.VUE_APP_URL_API_PLANILLA}/api/gestion-planilla/planilla/calcular-costo-plazas`;
        const body = {
          numero_plazas: this.solicitudPuestoForm.vacantesSolicitar,
          salario: aportaciones,
          id_solicitud: Number(this.$route.params.id),
          aguinaldo_salario_min: calcularConSalarioMin,
          salario_min: calcularConSalarioMin ? parseFloat(this.salarioMinimo) : 0,
          salarioMinimo: Number(this.salarioMinimo) || null,
          salarioMaximo: Number(this.salarioMaximo) || null
        };
        const response = await fetch(uri, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
          body: JSON.stringify(body)
        });

        if (response.ok) {
          const data = await response.json();
          this.cuadroAportaciones = {
            honorario: parseFloat(aportaciones) || 0,
            totalHonorariosMensual: data.data.total_honorarios_mensual_plaza,
            costoPlaza: data.data.costo_plaza,
            plazas: data.data.plazas,
            costoTotalPlazas: data.data.costo_total_plazas,
            isss: data.data.isss,
            afp: data.data.afp,
            isr: data.data.isr,
            totalIsss: data.data.total_plaza_isss,
            totalPlazaISSS: data.data.total_plaza_isss,
            totalAfp: data.data.total_plaza_afp,
            totalPlazaAFP: data.data.total_plaza_afp,
            totalIsr: data.data.total_plaza_isr,
            totalPlazaISR: data.data.total_plaza_isr,
            aguinaldoIndividual: data.data.aguinaldo,
            aguinaldoTotal: data.data.aguinaldo_total_plazas,
            salarioMinimo: Number(data.data.salario_minimo ?? this.salarioMinimo) || null,
            salarioMaximo: Number(data.data.salario_maximo ?? this.salarioMaximo) || null
          };

          // Sincronizar el salario propuesto con el honorario ingresado en el cuadro de aportaciones
          this.solicitudPuestoForm.salarioPropuesto = parseFloat(aportaciones) || 0;
        }
      } catch (error) {
        this.temporalAlert({
          show: true,
          message: error.message || "Error al calcular las aportaciones",
          type: "error"
        });
      } finally {
        this.setLoader(false);
      }
    },

    async verCuadroAportaciones() {
      try {
        this.setLoader(true);
        const id_solicitud = this.$route.params.id;

        // Usar axios directamente para manejar responseType arraybuffer
        const token = localStorage.getItem("token");
        const response = await this.axios({
          method: "get",
          url: `/api/v1/solicitud/reporte/${id_solicitud}`,
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (response.status === 200 && response.data) {
          // Convertir ArrayBuffer a Blob
          const blob = new Blob([response.data], { type: "application/pdf" });

          // Crear URL del blob para mostrarlo en el embed
          this.cuadroDocumentToView = URL.createObjectURL(blob);
          this.showCuadroDialog = true;
        }
      } catch (error) {
      } finally {
        this.setLoader(false);
      }
    }
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapState("solicitud", [
      "faseActual",
      "idDelegadoEmpleadoPuesto",
      "esFaseActivaUsuario",
      "tabOrigen",
      "solicitud",
      "mostrarCandidatosBolson"
    ]),
    isReadOnly() {
      return this.isView;
    },
    colsFilaPrincipal() {
      return this.tipoSolicitud === 2 ? 3 : 4;
    },
    plazaTextoView() {
      // En modo view, retornar el texto formateado de la plaza
      if (typeof this.solicitudPuestoForm.plazaSolicitar === "string") {
        return this.nombrePlazaSolicitar;
      }
      // Si es un objeto, formatear
      if (
        typeof this.solicitudPuestoForm.plazaSolicitar === "object" &&
        this.solicitudPuestoForm.plazaSolicitar
      ) {
        return `${this.solicitudPuestoForm.plazaSolicitar.nombre} - ${this.solicitudPuestoForm.vacantesDisponible}`;
      }
      return this.nombrePlaza || "";
    },
    tituloOfertaErrors() {
      const errors = [];
      if (!this.$v.solicitudPuestoForm.tituloOferta.$dirty) return errors;
      !this.$v.solicitudPuestoForm.tituloOferta.required &&
        errors.push("Título de la oferta es obligatorio");
      !this.$v.solicitudPuestoForm.tituloOferta.notEmojis &&
        errors.push("No debe incluir emojis");
      !this.$v.solicitudPuestoForm.tituloOferta.maxLength &&
        errors.push("Máximo 80 caracteres");

      return errors;
    },
    plazaSolicitarErrors() {
      const errors = [];
      if (!this.$v.solicitudPuestoForm.plazaSolicitar.$dirty) return errors;
      !this.$v.solicitudPuestoForm.plazaSolicitar.required &&
        errors.push("Plaza a solicitar es obligatorio");
      return errors;
    },
    sistemaPagoErrors() {
      const errors = [];
      if (!this.$v.solicitudPuestoForm.idSistemaPago.$dirty) return errors;
      !this.$v.solicitudPuestoForm.idSistemaPago.required &&
        errors.push("Sistema de pago es obligatorio");
      return errors;
    },
    partidaErrors() {
      const errors = [];
      if (!this.$v.solicitudPuestoForm.partida.$dirty) return errors;
      !this.$v.solicitudPuestoForm.partida.required &&
        errors.push("Cargo a solicitar es obligatorio");
      return errors;
    },
    cifradoErrors() {
      const errors = [];
      if (!this.$v.solicitudPuestoForm.cifrado.$dirty) return errors;
      !this.$v.solicitudPuestoForm.cifrado.required &&
        errors.push("Categoría es obligatorio");
      return errors;
    },
    vacantesSolicitarErrors() {
      const errors = [];
      if (!this.$v.solicitudPuestoForm.vacantesSolicitar.$dirty) return errors;

      !this.$v.solicitudPuestoForm.vacantesSolicitar.required &&
        errors.push("Vacantes a solicitar es obligatorio");
      !this.$v.solicitudPuestoForm.vacantesSolicitar.numeric &&
        errors.push("Debe ser un valor entero positivo");
      !this.$v.solicitudPuestoForm.vacantesSolicitar.minValue &&
        errors.push("Debe ser un valor mayor a 0");
      !this.$v.solicitudPuestoForm.vacantesSolicitar.validMaxVacantes &&
        this.$route.query.tipo == 2 &&
        errors.push(`Esta cantidad excede las vacantes disponibles`);

      return errors;
    },
    motivoErrors() {
      const errors = [];
      if (!this.$v.solicitudPuestoForm.motivo.$dirty) return errors;
      !this.$v.solicitudPuestoForm.motivo.required &&
        errors.push("Motivo es obligatorio");
      !this.$v.solicitudPuestoForm.motivo.notEmojis &&
        errors.push("No debe incluir emojis");
      !this.$v.solicitudPuestoForm.motivo.maxLength &&
        errors.push("Máximo 500 caracteres");
      return errors;
    },
    sexoErrors() {
      const errors = [];
      if (!this.$v.solicitudPuestoForm.sexo.$dirty) return errors;
      !this.$v.solicitudPuestoForm.sexo.required &&
        errors.push("Sexo es obligatorio");
      return errors;
    },
    salarioPropuestoErrors() {
      const errors = [];
      if (!this.$v.solicitudPuestoForm.salarioPropuesto.$dirty) return errors;
      !this.$v.solicitudPuestoForm.salarioPropuesto.required &&
        errors.push("Salario propuesto es obligatorio");
      !this.$v.solicitudPuestoForm.salarioPropuesto.validNumeric &&
        errors.push("Debe ser un valor numérico válido mayor a 0");
      !this.$v.solicitudPuestoForm.salarioPropuesto.minValue &&
        errors.push(`El salario no puede ser menor que el salario mínimo`);
      !this.$v.solicitudPuestoForm.salarioPropuesto.maxValue &&
        errors.push(`El salario no puede ser mayor que el salario máximo`);
      return errors;
    },

    calcularSalarioMaximo() {
      if (
        this.solicitudPuestoForm.plazaSolicitar !== null &&
        typeof this.solicitudPuestoForm.plazaSolicitar === "object"
      ) {
        return this.solicitudPuestoForm.plazaSolicitar
          ? this.solicitudPuestoForm.plazaSolicitar.salario_maximo
          : 0.0;
      } else {
        return 0.0;
      }
    },
    calcularSalarioMinimo() {
      if (
        this.solicitudPuestoForm.plazaSolicitar !== null &&
        typeof this.solicitudPuestoForm.plazaSolicitar === "object"
      ) {
        return this.solicitudPuestoForm.plazaSolicitar
          ? this.solicitudPuestoForm.plazaSolicitar.salario_minimo
          : 0.0;
      } else {
        return 0.0;
      }
    },
    salarioMax() {
      return !this.salarioMaximo
        ? "MAX No definido"
        : `${this.$currency.format(this.salarioMaximo)} MAX`;
    },
    validSalarioMaximo() {
      return this.salarioMaximo
        ? this.salarioMaximo
        : Number(this.solicitudPuestoForm.salarioPropuesto) + 0.01;
    },
    codigoFaseSolicitud() {
      return this.solicitud_fase_solicitud || null;
    },
    faseQuery() {
      return decodeFase(this.$route.query.fase);
    },

    mostrarCuadroAportaciones() {
      const cumpleFase =
        this.tipoSolicitud == 1 &&
        ["P14-F2", "P14-F3", "P14-F4", "P14-F5"].includes(this.faseQuery);
      const rutaVer = this.$route.name === "solicitud-view";
      return cumpleFase && !rutaVer;
    },
    mostrarCheckboxAguinaldo() {
      const fasesOcultarCheckbox = ["P14-F4", "P14-F5"];
      return this.calcularAguinaldo && !fasesOcultarCheckbox.includes(this.faseActual);
    },
    mostrarCuadroAportacionesServiciosProfesionales() {
      const cumpleFase =
        this.tipoSolicitud === 3 &&
        ["P15-F3", "P15-F6", "P15-F4", "P15-F5"].includes(this.faseQuery);
      const rutaVer = this.$route.name === "solicitud-view";
      return cumpleFase && !rutaVer;
    },
    isViewCuadroAportacionesServiciosProfesionales() {
      const esSedeCentral = [true, 1, "1", "true"].includes(this.solicitud?.sede_central);
      const esAdscrita = [true, 1, "1", "true"].includes(this.solicitud?.es_adscrita);
      if (!esSedeCentral || esAdscrita) return true;
      if (this.faseActual === "P15-F6" && Number(this.idEstado) === 4) return false;
      return ["P15-F6", "P15-F4", "P15-F5"].includes(this.faseActual);
    },
    mostrarDefinirSalario() {
      const cumpleFase =
        this.tipoSolicitud === 1 &&
        ["P14-F2", "P14-F3", "P14-F4", "P14-F5"].includes(this.faseActual);
      const rutaVer = this.$route.name === "solicitud-view";
      return cumpleFase && !rutaVer;
    },
    tieneRangoSalarialDefinido() {
      return Number(this.salarioMinimo) > 0 && Number(this.salarioMaximo) > 0;
    },
    mostrarSalarioAsignado() {
      const rutaVer = this.$route.name === "solicitud-view";
      const esAdscrita =
        this.solicitud?.es_adscrita === true ||
        this.solicitud?.es_adscrita === 1 ||
        this.solicitud?.es_adscrita === "true";
      if (this.faseActual === "P15-F3" && esAdscrita) return false;
      if (this.faseActual === "P15-F3" && !(Number(this.salarioAsignado) > 0)) return false;
      const cumpleFase =
        this.tipoSolicitud !== 2 &&
        ["P15-F3", "P15-F4", "P15-F5"].includes(this.faseActual);
      const cumpleP15F2 =
        this.tipoSolicitud === 3 &&
        this.faseActual === "P15-F2" &&
        this.tieneRangoSalarialDefinido;
      const cumpleFaseQueryAprobado =
        this.faseQuery === "P15-F3" && Number(this.$route.query.estado) === 7;
      const cumpleFaseQueryTipo2 =
        this.tipoSolicitud === 2 &&
        ((this.faseQuery === "P13-F2" && !this.esFaseActivaUsuario) ||
          this.faseQuery === "P13-F3");
      return (
        (cumpleP15F2 && !rutaVer) ||
        (cumpleFase && !rutaVer) ||
        cumpleFaseQueryAprobado ||
        cumpleFaseQueryTipo2
      );
    },

    mostrarCifradoAsignado() {
      if(!this.solicitud?.cifrado_presupuestario_asignado) return false;
      const cumpleFase =
        (this.tipoSolicitud == 1 || this.tipoSolicitud == 3) &&
        ["P15-F4", "P15-F5", "P14-F4", "P14-F5"].includes(this.faseActual);
      const rutaVer = this.$route.name === "solicitud-view";
      return cumpleFase && !rutaVer;
    },

    mostrarAsignacionSalario() {
      const perfilNoPermitido = ['Director'].includes(this.solicitud?.perfil);
      if(perfilNoPermitido) return false;
      if (
        this.tipoSolicitud === 3 &&
        this.faseActual === "P15-F2" &&
        !this.tieneRangoSalarialDefinido
      ) return false;
      const cumpleFase =
        ((this.tipoSolicitud === 3 && this.faseActual === "P15-F2") ||
          (this.tipoSolicitud === 2 && this.faseActual === "P13-F2")) &&
        this.esFaseActivaUsuario;
      const rutaVer = this.$route.name === "solicitud-view";
      const rutaAprobacion = this.$route.name === "aprobacion-solicitud";
      const token = localStorage.getItem("token");
      let userInfo = null;
      if (rutaVer) {
        return cumpleFase && !rutaVer;
      }
      if (token) {
        userInfo = jwtDecode(token);
      }
      if (this.idDelegadoEmpleadoPuesto === null) {
        return cumpleFase && !rutaVer;
      }
      if (
        rutaAprobacion &&
        userInfo?.puesto?.id === this.idDelegadoEmpleadoPuesto
      ) {
        return true;
      } else {
        return false;
      }
    },

    labelPlazaSolicitar() {
      if (this.tipoSolicitud === null) {
        return [1, 3].includes(Number(this.$route.query.tipo))
          ? "Plaza*"
          : "Plaza - Partida - Cantidad disponible*";
      }

      return [1, 3].includes(Number(this.tipoSolicitud))
        ? "Plaza*"
        : "Plaza - Partida - Cantidad disponible*";
    },
    sistemaPagoFijo() {
      if (
        this.$route?.query?.tipo == this.plazaGOES ||
        this.$route?.query?.tipo == this.PlazaServiciosProfesionales
      ) {
        return true;
      }
      return false;
    },
    rangoSalarioHint() {
      if (this.advertenciaRangoSalario) {
        return this.advertenciaRangoSalario;
      }
      if (this.salarioMinimo > 0 && this.salarioMaximo > 0) {
        return `Rango permitido: ${this.$currency.format(this.salarioMinimo)} - ${this.$currency.format(this.salarioMaximo)}`;
      }
      return "";
    }
  },
  watch: {
    solicitudPuestoForm: {
      handler(nuevoValor, viejoValor) {
        this.$emit("update:solicitud", nuevoValor);
      },
      deep: true
    },
    "solicitudPuestoForm.salarioPropuesto"(newVal) {
      // Actualizar el store solo si hay un valor
      const puedeEnviarSalario = this.faseQuery !== "P15-F2" || this.definirSalario;
      if (newVal && puedeEnviarSalario) {
        this.$store.dispatch("solicitud/setSalarioPropuesto", newVal);
      }
    },
    calcularSalarioMaximo(nuevoValor) {
      this.salarioMaximo = nuevoValor;
    },
    calcularSalarioMinimo(nuevoValor) {
      this.salarioMinimo = nuevoValor;
    },
    codigoFaseSolicitud(newVal) {
      this.$emit("update:faseSolicitud", newVal);
    },
    solicitud_fase_solicitud: {
      handler(newVal) {
        this.$emit("update:faseSolicitud", newVal);
        this.syncSolicitudStore({ fase: newVal });
      },
      deep: true,
      immediate: true
    },
    "solicitudPuestoForm.idSistemaPago"(newVal) {
      this.getPlaza();
    },
    "solicitudPuestoForm.vacantesDisponible"(newVal) {
      // Cuando cambia vacantesDisponible, re-validar vacantesSolicitar
      if (this.$v.solicitudPuestoForm.vacantesSolicitar.$dirty) {
        this.$v.solicitudPuestoForm.vacantesSolicitar.$touch();
      }
    },
    definirSalario(newVal) {
      if (newVal) {
        this.solicitudPuestoForm.salarioPropuesto = 0;
      } else {
        this.$v.solicitudPuestoForm.salarioPropuesto.$reset();
        this.advertenciaRangoSalario = "";
        if (this.faseQuery === "P15-F2") {
          this.$store.dispatch("solicitud/setSalarioPropuesto", null);
        }
      }
    },
    salarioMinimo() {
      // Re-validar cuando cambie el salario mínimo
      if (this.definirSalario && this.solicitudPuestoForm.salarioPropuesto) {
        this.validarRangoSalario(this.solicitudPuestoForm.salarioPropuesto);
      }
    },
    salarioMaximo() {
      // Re-validar cuando cambie el salario máximo
      if (this.definirSalario && this.solicitudPuestoForm.salarioPropuesto) {
        this.validarRangoSalario(this.solicitudPuestoForm.salarioPropuesto);
      }
    }
  },
  async created() {
    this.sistemaPagoContrato = Number(
      this.$route.query.id_sistema_pago ?? this.$route.query.sistema_pago
    ) || null;
    if (this.sistemaPagoFijo && this.sistemaPagoContrato) {
      this.searchPlaza();
    }
    this.getListadoPersonasDelegar();
    this.id_establecimiento = this.$route.params.establecimiento;
    this.isCreated = this.$route.params.hasOwnProperty("id");
    this.syncSolicitudStore({ solicitud: null });
    if (this.$route.params.id) {
      await this.getSolicitud();
      //this.getDocuments();
    } else {
      this.tipoSolicitud = Number(this.$route.query.tipo) || null;
    }

    await Promise.all([
      this.getTipoHorario(),
      this.getSexo(),
      this.getDirUniArea(),
      // this.getPlaza(),
      this.getSistemasPago()
    ]);

    this.$nextTick(() => {
      if (this.$refs.documentosSolicitud && this.itemsDocumentos.length > 0) {
        const mappedDocuments = this.itemsDocumentos.map((item) => ({
          nombre_archivo: item?.nombre_visible,
          id: item?.id
        }));
        this.$refs.documentosSolicitud.documentos = [...mappedDocuments];
      }
    });
    this.eventBus.$on("validarCampos", this.updateSolicitud);
  },
  async mounted() {
    const userToken = this.token || localStorage.getItem("token");
    const userDecode = jwtDecode(userToken);
    this.id_unidad_solicitante = userDecode?.puesto?.unidad_organizativa?.id;

    if (this.$refs?.documentosSolicitud?.documentos) {
      const mappedDocuments = this.itemsDocumentos.map((item) => ({
        nombre_archivo: item?.nombre_visible,
        id: item?.id
      }));

      this.$nextTick(() => {
        this.$refs.documentosSolicitud.documentos = [...mappedDocuments];
      });
    }
  },
  beforeDestroy() {
    this.syncSolicitudStore({ solicitud: null, fase: null });
    this.eventBus.$off("validarCampos", this.updateSolicitud);
  }
};
</script>
